/**
 * Swiper `renderBullet` that renders each bullet as a labelled button.
 */
export function renderBulletButton(index, className) {
  // `t` has already HTML-escaped the translation; quotes are escaped again in
  // case it ever arrives raw, as they would end the attribute.
  const label = window.localeStrings.accessibility.go_to_slide
    .replace("[index]", index + 1)
    .replaceAll('"', "&quot;");

  return `<button type="button" class="${className}" aria-label="${label}"></button>`;
}

/**
 * Mirrors the active bullet class onto `aria-current`. Swiper's A11y module
 * does this too, but only when it's loaded.
 */
export function syncBulletCurrent(swiper) {
  const activeClass = swiper.params.pagination.bulletActiveClass;

  swiper.pagination?.bullets?.forEach((bullet) => {
    if (bullet.classList.contains(activeClass)) {
      bullet.setAttribute("aria-current", "true");
    } else {
      bullet.removeAttribute("aria-current");
    }
  });
}
